import { Injectable, signal } from '@angular/core';
import { EMPTY, from } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { unwrapData } from 'src/app/infrastructure/functions/unwrap-data.operator';
import { TPhotoName } from 'src/app/infrastructure/models/image-type';
import { fileTypeLimitsDto, IFileTypeLimitsDto } from 'src/assets/common/models/file-type-limits-dto.g';

// Maximum aantal foto's per lijst per fototype (FileType.MaxFiles, AdminPanel › configuration; alleen typen op
// gebruikersniveau, nu de eigen fotopool). Eén keer geladen bij het eerste gebruik; refresh() na opslaan in de
// configuratie-tab. Ontbreekt een type, dan is het onbeperkt. De backend (PhotoController.Save →
// UploadLimitReached) blijft de harde poort.
@Injectable({ providedIn: 'root' })
export class UploadLimitService {
    private readonly __apiService = injectRequired(ApiService);

    private readonly __limits$$ = signal<ReadonlyMap<string, number>>(new Map());
    private __loaded = false;

    // null = onbeperkt. Leest het signal, dus reactief in een computed.
    maxFiles_get(photoType: TPhotoName | null | undefined): number | null {
        return photoType ? this.__limits$$().get(photoType) ?? null : null;
    }

    // Eerste gebruiker (fotolijst) laadt de limieten; daarna alleen nog via refresh().
    load(): void {
        if (!this.__loaded) this.refresh();
    }

    refresh(): void {
        this.__loaded = true;
        from(this.__apiService.GET('/api/FileType/upload-limits')).pipe(
            unwrapData(),
            catchError(() => EMPTY),
        ).subscribe(data => {
            const __list = ((data as any)?.list ?? []) as IFileTypeLimitsDto[];
            this.__limits$$.set(new Map(__list
                .filter(dto => dto[fileTypeLimitsDto.maxFiles] != null)
                .map(dto => [dto[fileTypeLimitsDto.fileType]!, dto[fileTypeLimitsDto.maxFiles]!])));
        });
    }
}
